module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/dara-cohen-4087db59a1a3c41b77e7c0933370c750.jpg";